import { renderIcon } from '@opallabs/kuiper'
import { getNestedProperty } from '@opallabs/lambda'
import { Module } from '../../../helpers/types.js'
import laughImg from './laugh.png'
import likeImg from './like.png'
import loveImg from './love.png'
import { styles } from './styles'

type Props = {
  index: number
  repliesEnabled?: boolean
  sections: Module[]
  sharingEnabled?: boolean
}

export const FacebookStoryFooter: React.FC<Props> = ({
  index,
  repliesEnabled = false,
  sections,
  sharingEnabled = false,
}) => {
  const fbStoryCTA = getNestedProperty(
    sections,
    index.toString(),
    'fbStoryCarouselCtaOption'
  )
  const cta =
    typeof fbStoryCTA === 'object'
      ? getNestedProperty(fbStoryCTA, 'selected', 'title')
      : fbStoryCTA
  const hasRepliesOrCta = repliesEnabled || cta

  return (
    <div css={styles.footerWrapper}>
      <div css={styles.footer}>
        <div css={styles.getFooterContent(cta)}>
          <div css={styles.getShareReplyWrapper(cta)}>
            {sharingEnabled && (
              <div css={styles.getSharingWrapper(hasRepliesOrCta)}>
                <ul css={styles.icons}>
                  <li css={styles.getShareIconPadding(hasRepliesOrCta)}>
                    {renderIcon('facebook-mobile-story-share', {
                      height: 20,
                      width: 20,
                      ariaMode: 'hidden',
                    })}
                  </li>
                </ul>
                {hasRepliesOrCta ? '' : 'Share'}
              </div>
            )}
            {repliesEnabled && !cta && (
              <div css={styles.getReplyWrapper(sharingEnabled)}>
                Reply to...
              </div>
            )}
            {cta && (
              <div css={styles.ctaWrapper}>
                <div css={styles.ctaChevronWrapper}>
                  {renderIcon('facebook-mobile-story-chevron-up', {
                    height: 8,
                    width: 18,
                    ariaMode: 'hidden',
                  })}
                  <div css={styles.cta}>{cta}</div>
                </div>
              </div>
            )}
          </div>
          <div css={styles.iconsWrapper}>
            <ul css={styles.icons}>
              <li css={styles.getIconPadding(cta)}>
                <img
                  src={likeImg}
                  alt="Facebook mobile story social like icon"
                  height={40}
                  width={40}
                />
              </li>
              <li css={styles.getIconPadding(false)}>
                <img
                  src={loveImg}
                  alt="Facebook mobile story social love icon"
                  height={40}
                  width={40}
                />
              </li>
              <li>
                <img
                  src={laughImg}
                  alt="Facebook mobile story social laugh icon"
                  height={40}
                  width={40}
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
